import React from "react"
import { observer } from "mobx-react-lite"
import { ScrollView } from "~/ui/primitives"
import { useSafeAreaInsets } from "~/ui/safe-area"
import styled, { useTheme } from "~/ui/styled"
import { StartFlex, ColumnFlex, BetweenFlex, Text } from "~components/El"
import { Avatar } from "~widgets/avatar"
import { useActiveChat } from "~hooks/useActiveChat"
import { GroupChatAnnouncementDetailScreenProps } from "./types"
import { scrollViewFillStyle } from "~/ui/scroll-layout"

const Container = styled.View`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.blockBackground};
  padding: 0 15px;
`


const GroupChatAnnouncementDetailScreen: React.FC<GroupChatAnnouncementDetailScreenProps> = () => {
  const theme = useTheme()
  const insets = useSafeAreaInsets()
  const { chat } = useActiveChat()

  if (!chat) return null

  return (
    <Container>
        <BetweenFlex width="100%" padding="10px 0">
            <StartFlex>
                <Avatar avatar={chat?.image} size={40} name={chat?.title} />
                <ColumnFlex ml="10px">
                    <Text numberOfLines={1} color={theme.colors.text} fontSize={theme.fontSizes.lg} fontWeight="600">{chat?.title}</Text>
                    <Text color={theme.colors.secondaryText} fontSize={theme.fontSizes.md}>共{chat?.members?.length}{chat.chatTypeEnum === "CHANNEL" ? "订阅" : "人"}</Text>
                </ColumnFlex>
                
            </StartFlex>
        </BetweenFlex>
        <ScrollView
            style={scrollViewFillStyle}
            showsVerticalScrollIndicator={false}
            keyboardShouldPersistTaps="handled"
            contentContainerStyle={{ paddingBottom: insets.bottom + 60 }}
        >
            <Text color={theme.colors.text} fontSize={14} lineHeight="20px" >{chat?.desc || `${chat.chatTypeEnum === "CHANNEL" ? "暂无简介" : "暂无公告"}`}</Text>
        </ScrollView>
    </Container>
  )
}

export default observer(GroupChatAnnouncementDetailScreen)
